import React, {useState} from 'react'
import ClipLoader from "react-spinners/ClipLoader";

const BasketItem = (props) => {

  const [fillMinus, setFillMinus] = useState(false)
  const [fillPlus, setFillPlus] = useState(false)
  const [removingItem, setRemovingItem] = useState(false)

  const overrideSmaller = {
    display: "flex",
    borderWidth: '2.5px',
    height: '18px',
    width: '18px',
    position:'absolute',
    left:'calc(50% - 9px)',
    top: 'calc(50% - 9px)',
    bottom:'45px',
    zIndex:'2'
  };

  return (
      <div className={!props.isCheckout ? 'basket_item' : 'basket_item checkout'}>
          <img
              className='basket_item_img'
              src={props.image}
              alt={"Category Item"}
              loading="eager">
          </img>
          <div className='basket_item_info_container'>
              <div className='basket_item_title_container'>
                <img
                className='basket_item_img_small'
                src={props.image}
                alt={"Category Item"}
                loading="eager">
                </img>
                  <div className='basket_item_title_wrapper'>
                    <h3 className='basket_item_title'>{props.title.toUpperCase()}
                        {props.servings &&
                            <span className='basket_item_title'>
                            (<img
                                className={'servings_icon'}
                                alt='Group Icon'
                                src={require('./../../images/icon-group.png')}
                                loading="eager"
                            />
                                {props.servings})</span>
                        }
                    </h3>

                  </div>
              </div>
              <div className='basket_item_info'>
                  <span className='item_quantity'>QUANTITY</span>
                  <div className='quantity_selector' style={{justifySelf:'right', alignSelf:'center'}}>
                    { props.isConfirmation ?
                      <h3 className='quantity_of_item'>{props.quantity}</h3>
                    :
                      <>
                        <button 
                          className={fillMinus ? 'increment_btn inactive_add' : 'increment_btn'}
                          style={{height:'28px', width:'28px', marginRight:'5px'}} 
                          onClick={() => {
                            props.updateItemBasketQuantity(props.id, props.quantity - 1)
                            setFillMinus(true)
                            setTimeout(() => {
                              setFillMinus(false)
                            }, 1000)
                          }}
                          ><ClipLoader
                          color={'#fff'}
                          loading={fillMinus}
                          cssOverride={overrideSmaller}
                          size={'50px'}
                          aria-label="Loading Spinner"
                          data-testid="loader"
                        />-</button>
                        <h3 className='quantity_of_item'>{props.quantity}</h3>
                        <button 
                          className={fillPlus ? 'increment_btn inactive_add' : 'increment_btn'}
                          style={{height:'28px', width:'28px', marginLeft:'5px'}} 
                          onClick={() => {
                            props.updateItemBasketQuantity(props.id, props.quantity + 1)
                            setFillPlus(true)
                            setTimeout(() => {
                              setFillPlus(false)
                            }, 1000)
                          }}
                            ><ClipLoader
                            color={'#fff'}
                            loading={fillPlus}
                            cssOverride={overrideSmaller}
                            size={'50px'}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />+</button>
                      </>
                    }
                  </div>
                  { props.isConfirmation ?
                  <span className='item_quantity'>PRICE</span>
                  :
                  <div className='empty_container'>
                    <span className={removingItem ? 'remove_item hide' : 'remove_item'}
                      onClick={() => {
                        props.removeFromBasket(props.id)
                        setRemovingItem(true)
                        setTimeout(() => {
                          setRemovingItem(false)
                        }, 3500)
                      }} 
                    >REMOVE</span>
                    <ClipLoader
                      color={'#C30D0D'}
                      loading={removingItem}
                      cssOverride={overrideSmaller}
                      size={'50px'}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  </div> 
                  }
                  <h3 className='item_price'>£{parseFloat(props.price).toFixed(2)}</h3>
              </div>
          </div>
      </div>
  )
}

export default BasketItem